import React from 'react';
import { Redirect } from 'react-router-dom';

import { withServerData, config, Status } from '@xingternal/hops';

const RedirectLoggedIn = ({
  serverData: {
    login: { loginState },
  },
}) => {
  if (loginState === 'LOGGED_IN') {
    return (
      <>
        <Status code={302} />
        <Redirect to={config.loggedInStartPageUrl} />
      </>
    );
  }

  return null;
};

export default withServerData(RedirectLoggedIn);
